export const MAILTO_HANDLER_OPERATION: string = 'mailtoHandlerOperation';
export const MAILTO_HANDLER_OPERATION_TIME: string = 'mailtoHandlerOperationTime';
export const MAILTO_HANDLER_IGNORED_COUNT: string = 'mailtoHandlerIgnoredCount';
export const MAILTO_HANDLER_MAX_IGNORED_COUNT: number = 14;
export const LOCAL_STORAGE_TTL: number = 60 * 1000 * 60 * 24 * 7;

export const enum OperationType {
    TryItNow = 'TryItNow',
    Close = 'Close',
    AskMeLater = 'AskMeLater',
}
